import { useRevalidateStatusStore } from '@/data/operation/store';
import { Text } from '@typedream/ui';
import useCurrentPagePath from '../../utils/useCurrentPagePath';
import styles from './PublishButton.module.css';
import PublishLink from './PublishLink';

function PublishedLinks({ published }: { published: boolean }) {
  const { typedreamSubdomain, customDomain, currentPathWithoutSlug } = useCurrentPagePath();

  const pathWithoutSlug = `${currentPathWithoutSlug ? `/${currentPathWithoutSlug}` : ''}`;

  const { status } = useRevalidateStatusStore();
  const revalidated = status?.endpoints || {};
  const subdomainRevalidateEndpoint = typedreamSubdomain.split('/')[0];
  const subdomainEndpoint = subdomainRevalidateEndpoint.includes('localhost')
    ? `http://${subdomainRevalidateEndpoint}`
    : `https://${subdomainRevalidateEndpoint}`;
  const customDomainEndpoint = `https://${customDomain}`;

  return (
    <div className={styles.item}>
      <div className="flex flex-col flex-1">
        <Text as="p" className="mb-2" size="xs" weight="medium">
          {published ? 'Published' : 'Publish'} domain
        </Text>
        <div>
          <PublishLink
            published={published && revalidated[subdomainEndpoint]?.status === 'succeeded'}
            error={
              !!revalidated[subdomainEndpoint] &&
              revalidated[subdomainEndpoint]?.status === 'failed'
            }
            url={`${typedreamSubdomain}${pathWithoutSlug}`}
          />
        </div>
        <div>
          {customDomain && (
            <PublishLink
              published={published && revalidated[customDomainEndpoint]?.status === 'succeeded'}
              error={
                !!revalidated[customDomainEndpoint] &&
                revalidated[customDomainEndpoint]?.status === 'failed'
              }
              url={`${customDomain}${pathWithoutSlug}
          `}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default PublishedLinks;
